import axios from 'axios';
import BaseAPI from './base/base-api';

class ImportAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'import';
}

export default new ImportAPI();
